import React from "react";
import {
    Box,
    Button, FormControl, FormErrorMessage, FormLabel, Grid, Input,
    NumberInput,
    NumberInputField,
    InputGroup,
    InputLeftAddon,
    Stack,
    Switch,
    Text,
    useColorModeValue,
    GridItem
} from "@chakra-ui/react";
import {
    MdSave,
} from "react-icons/md";
import { useNewCompany } from "../hooks/useNewCompany";
import InputMask from "react-input-mask";

type NewCompanyFormProps = Pick<useNewCompany.type, "state" | "showModal" | "changeInput" | "changeAddressInput" | "changeContactInput" | "saveCompany" | "displayInputError">;

const NewCompanyForm: React.FC<NewCompanyFormProps> = ({ state, showModal, changeInput, changeAddressInput, changeContactInput, saveCompany, displayInputError }) => {

    const textColor = useColorModeValue("navy.700", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");

    return (
        <Box w="100%">
            <Box
                px="0px"
                mb="16px"
                mt="0px"
                justifyContent="space-between"
            >
                <Stack direction="row" spacing={4}>
                    <Button
                        leftIcon={<MdSave />}
                        colorScheme="brand"
                        size={"sm"}
                        variant="solid"
                        isLoading={state.loading}
                        onClick={saveCompany}
                    >
                        Salvar
                    </Button>
                </Stack>
            </Box>
            <Box w="100%">
                <Grid
                    templateColumns='repeat(6, 1fr)'
                    templateRows='repeat(4, 1fr)'
                    gap={4}
                    mb={4}
                >

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("razaoSocial").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Razão Social<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Nome da Razão Social"
                                fontWeight="500"
                                defaultValue={state.company.razaoSocial}
                                size="md"
                                autoFocus={true}
                                onBlur={(e) => changeInput({ type: "razaoSocial", payload: e.target.value })}
                            />

                            {displayInputError("razaoSocial").error && (
                                <FormErrorMessage>{displayInputError("razaoSocial").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("nomeFantasia").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Nome Fantasia<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Nome Fantasia"
                                fontWeight="500"
                                defaultValue={state.company.nomeFantasia}
                                size="md"
                                onBlur={(e) => changeInput({ type: "nomeFantasia", payload: e.target.value })}
                            />

                            {displayInputError("nomeFantasia").error && (
                                <FormErrorMessage>{displayInputError("nomeFantasia").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("cnpj").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                CNPJ<Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o CNPJ"
                                fontWeight="500"
                                defaultValue={state.company.cnpj}
                                size="md"
                                onBlur={(e) => changeInput({ type: "cnpj", payload: e.target.value })}
                                as={InputMask}
                                mask={"99.999.999/9999-99"}
                            />

                            {displayInputError("cnpj").error && (
                                <FormErrorMessage>{displayInputError("cnpj").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} display="flex">
                        <FormControl isInvalid={displayInputError("inscricaoEstadual").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Inscricao Estadual<Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="number"
                                placeholder="Preencha a Inscricao Estadual"
                                fontWeight="500"
                                defaultValue={state.company.inscricaoEstadual}
                                size="md"
                                onBlur={(e) => changeInput({ type: "inscricaoEstadual", payload: e.target.value })}
                            />

                            {displayInputError("inscricaoEstadual").error && (
                                <FormErrorMessage>{displayInputError("inscricaoEstadual").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>

                        <FormControl w={35} mx={4}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Isento <Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Switch
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={false}
                            // onChange={(e) => changeInput({ type: "matriz", payload: e.target.checked })}
                            />
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("inscricaoMunicipal").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Inscricao Municipal<Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="number"
                                placeholder="Preencha a Inscricao Municipal"
                                fontWeight="500"
                                defaultValue={state.company.inscricaoMunicipal}
                                size="md"
                                onBlur={(e) => changeInput({ type: "inscricaoMunicipal", payload: e.target.value })}
                            />

                            {displayInputError("inscricaoMunicipal").error && (
                                <FormErrorMessage>{displayInputError("inscricaoMunicipal").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} display="flex">
                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Matriz<Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={state.company.matriz}
                                onChange={(e) => changeInput({ type: "matriz", payload: e.target.checked })}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Ativo<Text color={brandStars}>*</Text>
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={state.company.ativo}
                                onChange={(e) => changeInput({ type: "ativo", payload: e.target.checked })}
                            />
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} />

                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("cnae").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                CNAE <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o CNAE"
                                fontWeight="500"
                                defaultValue={state.company.cnae}
                                size="md"
                                onBlur={(e) => changeInput({ type: "cnae", payload: e.target.value })}
                            />

                            {displayInputError("cnae").error && (
                                <FormErrorMessage>{displayInputError("cnae").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("atividadePrincipal").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Atividade principal<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha a atividade principal"
                                fontWeight="500"
                                defaultValue={state.company.atividadePrincipal}
                                size="md"
                                onBlur={(e) => changeInput({ type: "atividadePrincipal", payload: e.target.value })}
                            />

                            {displayInputError("atividadePrincipal").error && (
                                <FormErrorMessage>{displayInputError("atividadePrincipal").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("regimeTributario").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Código de regime tributario <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Código de regime tributario"
                                fontWeight="500"
                                defaultValue={state.company.regimeTributario}
                                size="md"
                                onBlur={(e) => changeInput({ type: "regimeTributario", payload: e.target.value })}
                            />

                            {displayInputError("regimeTributario").error && (
                                <FormErrorMessage>{displayInputError("regimeTributario").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("tamanhoEmpresa").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Tamanho da empresa <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o tamanho da empresa"
                                fontWeight="500"
                                defaultValue={state.company.tamanhoEmpresa}
                                size="md"
                                onBlur={(e) => changeInput({ type: "tamanhoEmpresa", payload: e.target.value })}
                            />

                            {displayInputError("tamanhoEmpresa").error && (
                                <FormErrorMessage>{displayInputError("tamanhoEmpresa").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} display="flex">
                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Comércio
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={state.company.comercio}
                                onChange={(e) => changeInput({ type: "comercio", payload: e.target.checked })}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                E-commerce
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={state.company.ecommerce}
                                onChange={(e) => changeInput({ type: "ecommerce", payload: e.target.checked })}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Indústria
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={state.company.industria}
                                onChange={(e) => changeInput({ type: "industria", payload: e.target.checked })}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Serviços
                            </FormLabel>

                            <Switch
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="checkbox"
                                fontWeight="500"
                                size="md"
                                isChecked={false}
                                onChange={(e) => changeInput({ type: "servicos", payload: e.target.checked })}
                            />
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("faturamentoUltimoAno").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Faturamento do último ano <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <InputGroup>
                                <InputLeftAddon>R$</InputLeftAddon>
                                <NumberInput
                                    precision={2}
                                    min={0}
                                    isRequired={true}
                                    fontSize="sm"
                                    ms={{ base: "0px", md: "0px" }}
                                    placeholder="Preencha o Faturamento do último ano"
                                    fontWeight="500"
                                    defaultValue={state.company.faturamentoUltimoAno}
                                    size="md"
                                    onBlur={(e) => changeInput({ type: "faturamentoUltimoAno", payload: e.target.value })}
                                >
                                    <NumberInputField />
                                </NumberInput>
                            </InputGroup>

                            {displayInputError("faturamentoUltimoAno").error && (
                                <FormErrorMessage>{displayInputError("faturamentoUltimoAno").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("quantidadeFuncionarios").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Quantidade de funcionários <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Quantidade de funcionários"
                                fontWeight="500"
                                defaultValue={state.company.quantidadeFuncionarios}
                                size="md"
                                onBlur={(e) => changeInput({ type: "quantidadeFuncionarios", payload: e.target.value })}
                            />

                            {displayInputError("quantidadeFuncionarios").error && (
                                <FormErrorMessage>{displayInputError("quantidadeFuncionarios").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>
                </Grid>

                <Text
                    mt={8}
                    fontSize={18}
                    color={"#422AFB"}
                    fontWeight={"bold"}
                    mb={4}
                >
                    Endereço
                </Text>

                <Grid
                    templateColumns='repeat(6, 1fr)'
                    templateRows='repeat(2, 1fr)'
                    gap={4}
                >
                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.cep").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                CEP<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o cep"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0]?.cep}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "cep", payload: e.target.value })}
                                as={InputMask}
                                mask={"99999-999"}
                            />

                            {displayInputError("EnderecoEmpresa.cep").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.cep").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.estado").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                UF<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o UF"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].estado}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "estado", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.estado").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.estado").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.cidade").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Cidade <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o nome da cidade"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].cidade}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "cidade", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.cidade").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.cidade").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.bairro").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Bairro <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o nome do bairro"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].bairro}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "bairro", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.bairro").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.bairro").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.local").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Endereço <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o endereço"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].local}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "local", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.local").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.local").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.numero").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Numero <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o numero"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].numero}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "numero", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.numero").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.numero").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={3} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("EnderecoEmpresa.complemento").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Complemento <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o complemento"
                                fontWeight="500"
                                defaultValue={state.company.EnderecoEmpresa[0].complemento}
                                size="md"
                                onBlur={(e) => changeAddressInput({ type: "complemento", payload: e.target.value })}
                            />

                            {displayInputError("EnderecoEmpresa.complemento").error && (
                                <FormErrorMessage>{displayInputError("EnderecoEmpresa.complemento").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>
                </Grid>

                <Text
                    mt={8}
                    fontSize={18}
                    color={"#422AFB"}
                    fontWeight={"bold"}
                    mb={4}
                >
                    Contato
                </Text>

                <Grid
                    templateColumns='repeat(6, 1fr)'
                    templateRows='repeat(1, 1fr)'
                    gap={4}
                >
                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("ContatoEmpresa.nome").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Nome<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Nome de contato"
                                fontWeight="500"
                                defaultValue={state.company.ContatoEmpresa[0].nome}
                                size="md"
                                onBlur={(e) => changeContactInput({ type: "nome", payload: e.target.value })}
                            />

                            {displayInputError("ContatoEmpresa.nome").error && (
                                <FormErrorMessage>{displayInputError("ContatoEmpresa.nome").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={1} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("ContatoEmpresa.telefone").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                Telefone<Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="text"
                                placeholder="Preencha o Numero de Telefone"
                                fontWeight="500"
                                defaultValue={state.company.ContatoEmpresa[0].telefone}
                                size="md"
                                onBlur={(e) => changeContactInput({ type: "telefone", payload: e.target.value })}
                                as={InputMask}
                                mask={"(99) 99999-9999"}
                            />

                            {displayInputError("ContatoEmpresa.telefone").error && (
                                <FormErrorMessage>{displayInputError("ContatoEmpresa.telefone").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>

                    <GridItem colSpan={2} rowSpan={1} >
                        <FormControl isInvalid={displayInputError("ContatoEmpresa.email").error}>
                            <FormLabel
                                display="flex"
                                ms="4px"
                                fontSize="sm"
                                fontWeight="500"
                                color={textColor}
                                mb="8px"
                            >
                                E-mail <Text color={brandStars}>*</Text>
                            </FormLabel>
                            <Input
                                isRequired={true}
                                fontSize="sm"
                                ms={{ base: "0px", md: "0px" }}
                                type="email"
                                placeholder="Preencha o E-mail de contato"
                                fontWeight="500"
                                defaultValue={state.company.ContatoEmpresa[0].email}
                                size="md"
                                onBlur={(e) => changeContactInput({ type: "email", payload: e.target.value })}
                            />

                            {displayInputError("ContatoEmpresa.email").error && (
                                <FormErrorMessage>{displayInputError("ContatoEmpresa.email").errorMessage}</FormErrorMessage>
                            )}
                        </FormControl>
                    </GridItem>
                </Grid>
            </Box>
        </Box>
    );
}

export default NewCompanyForm;
